import React from 'react'

import { lightBlueFontColor } from 'assets/styles/variables'

type Props = {
  icon: React.ReactNode
}

export const IconCards: React.FC<Props> = ({ icon }) => {
  return (
    <div
      style={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 40px)',
        gridTemplateRows: 'repeat(4, 40px)',
        perspective: '1200px',
      }}
    >
      {/* Back card */}
      <div
        style={{
          gridArea: '1 / 1 / span 2 / span 2',
          width: '100%',
          height: '100%',
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E0E0E0',
          boxShadow: '-4px 4px 0px #E0E0E0, -8px 8px 10px rgba(0, 0, 0, 0.05)',
          zIndex: 1,
          transform: 'rotateY(25deg) rotateX(5deg)',
          color: lightBlueFontColor,
          fontSize: '44px',
        }}
      >
        <div style={{ opacity: 0.5 }}>{icon}</div>
      </div>

      {/* Middle card */}
      <div
        style={{
          gridArea: '2 / 2 / span 2 / span 2',
          width: '100%',
          height: '100%',
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #f3f4f6 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #D6D6D6',
          boxShadow: '-4px 4px 0px #D6D6D6, -8px 8px 10px rgba(0, 0, 0, 0.05)',
          zIndex: 2,
          transform: 'rotateY(25deg) rotateX(5deg)',
          color: lightBlueFontColor,
          fontSize: '44px',
        }}
      >
        <div style={{ opacity: 0.75 }}>{icon}</div>
      </div>

      {/* Front card */}
      <div
        style={{
          gridArea: '3 / 3 / span 2 / span 2',
          width: '100%',
          height: '100%',
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #C8C8C8',
          boxShadow: '-5px 5px 0px #C8C8C8, -10px 10px 20px rgba(0, 0, 0, 0.1)',
          zIndex: 3,
          transform: 'rotateY(25deg) rotateX(5deg)',
          color: lightBlueFontColor,
          fontSize: '44px',
        }}
      >
        {icon}
      </div>
    </div>
  )
}
